module.exports = __webpack_public_path__ + "static/media/Sharp-Press-Landing-Page-Hero-2.e83ab5b7.jpg";